jQuery(document).ready(function($) {
	$('.top_carousel').slick({
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        dots: true,
        arrows: false,
        appendDots: '.controller',
        appendArrows: '.controller',
        autoplay: false,
      });

      $(function(){
        var beforePos = 0; // スクロールの値の比較用の設定
    
        // スクロール途中でヘッダーが消え、上にスクロールすると復活する設定を関数にまとめる
        function ScrollAnime() {
          var scroll = $(window).scrollTop();
          var scrollThreshold = 100; // この位置より上では常に表示
          
          // ヘッダーの出し入れをする
          if (scroll <= scrollThreshold) {
            // ページ上部では常に表示
            $('header').removeClass('header-hidden');
          } else if (scroll > beforePos) {
            // 下にスクロールした時はヘッダーを隠す
            $('header').addClass('header-hidden');
          } else if (scroll < beforePos) {
            // 上にスクロールした時はヘッダーを表示
            $('header').removeClass('header-hidden');
          }
          
          beforePos = scroll; // 現在のスクロール値を比較用のbeforePosに格納
        }
    
        // 画面をスクロールをしたら動かしたい場合の記述
        $(window).scroll(function () {
          ScrollAnime(); // スクロール途中でヘッダーが消え、上にスクロールすると復活する関数を呼ぶ
        });
    
        // ページが読み込まれたらすぐに動かしたい場合の記述
        $(window).on('load', function () {
          ScrollAnime(); // スクロール途中でヘッダーが消え、上にスクロールすると復活する関数を呼ぶ
        });
    
    
    
    
        //リンク先のidまでスムーススクロール
        //※ページ内リンクを行わない場合は不必要なので削除してください
            var headerH = $("#header").outerHeight(true);//headerの高さを取得    
            $('#g-navi li a').click(function () {
          var elmHash = $(this).attr('href'); 
          var pos = $(elmHash).offset().top-headerH;//header分の高さを引いた高さまでスクロール
          $('body,html').animate({scrollTop: pos}, 1000);
          return false;
        });
      });

      $(".search_open").click(function(){
        $(this).addClass("open");
        $(".search_bg").addClass("active");
        $("body").addClass("modal_open");
      });
      $(document).on('click touchend',function(e) {
        if(!$(e.target).closest('.search_open').length) {
         if(!$(e.target).closest('#searchform').length) {
           $("#searchform input ").val("");
           $(".search_open").removeClass("open");
           $(".search_bg").removeClass("active");
           if($("body").hasClass("modal_open")){
            $("body").removeClass("modal_open");
           }
         }
        }else{
         if($(e.target).closest('.clear').length) {
           $("#searchform input").val("");
           $(".search_open").removeClass("open");
           $(".search_bg").removeClass("active");
         }
        }
     });
     $(".search_area .clear").click(function(){
       $(".search_area input").val("");
     });

    

     $(function(){
      $(".header_nav_sp").off('click').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        $("header nav.header-nav").toggleClass("active");
      });
     });

     $(function(){
      $(".tags li").hover(function() {
        $(this).parents("a").parent().addClass("disable");
      },
      function() {
        $(this).parents("a").parent().removeClass("disable");
      });
    });
    $(function() {
      $('[data-tag]').on('click', function(e) {
          e.preventDefault();
          var url = $(this).data('tag');
          location.href = url;
      });
    });

    // $(function(){
    //   function fitText() {
    //     // ウィンドウサイズが767px以下のときのみ処理
    //     if (window.innerWidth > 767) {
    //       return;
    //     }
        
    //     // 全ての.fit-text要素を処理
    //     $(".fit-text").each(function(){
    //       var $el = $(this);
    //       var text = $el.text().trim();
    //       var $dialogContent = $el.closest('.dialog_content');
          
    //       if ($dialogContent.length === 0) {
    //         return;
    //       }
          
    //       // 半角スペースまでの文字数をカウント
    //       var spaceIndex = text.indexOf(' ');
    //       var charsBeforeSpace = spaceIndex !== -1 ? spaceIndex : text.length;
          
    //       // ダイアログの幅は85vwで固定
    //       var dialogContentWidth = window.innerWidth * 0.85 - 50;
    //       var viewportWidth = window.innerWidth;
          
    //       // 元のフォントサイズを取得（CSS変数を一時的に削除してCSSから取得）
    //       // リサイズ時にも正しく取得できるように、既存のCSS変数を一時的に削除
    //       var tempOriginalPx = $el[0].style.getPropertyValue('--original-font-size-px');
    //       if (!tempOriginalPx) {
    //         // 初回取得時はCSS変数がないので、インラインスタイルを削除して取得
    //         $el.css('font-size', '');
    //         tempOriginalPx = parseFloat($el.css('font-size')) + 'px';
    //       }
    //       var originalFontSizePx = parseFloat(tempOriginalPx) || parseFloat($el.css('font-size'));
          
    //       // フォントがはみ出さないようになるフォントサイズを計算（px単位）
    //       var calculatedFontSizePx = 0;
    //       if (charsBeforeSpace > 0) {
    //         calculatedFontSizePx = dialogContentWidth / charsBeforeSpace;
    //       }
          
    //       // vw単位に変換
    //       var calculatedFontSizeVw = 0;
    //       if (viewportWidth > 0 && charsBeforeSpace > 0) {
    //         calculatedFontSizeVw = (calculatedFontSizePx / viewportWidth) * 100;
    //       }
          
    //       console.log('文字列:', text);
    //       console.log('半角スペースまでの文字数:', charsBeforeSpace);
    //       console.log('.dialog_contentの幅:', dialogContentWidth);
    //       console.log('元のフォントサイズ:', originalFontSizePx + 'px');
    //       console.log('計算されたフォントサイズ (px):', calculatedFontSizePx);
    //       console.log('計算されたフォントサイズ (vw):', calculatedFontSizeVw + 'vw');
          
    //       // CSS変数として計算したvw値と元のpx値を設定
    //       if (calculatedFontSizeVw > 0 && originalFontSizePx > 0) {
    //         $el[0].style.setProperty('--calculated-font-size-vw', calculatedFontSizeVw + 'vw');
    //         $el[0].style.setProperty('--original-font-size-px', originalFontSizePx + 'px');
    //         console.log('CSS変数を設定: --calculated-font-size-vw =', calculatedFontSizeVw + 'vw');
    //         console.log('CSS変数を設定: --original-font-size-px =', originalFontSizePx + 'px');
    //       }
    //     });
    //   }
      
    //   // 読込時に処理を実行
    //   $(window).on('load', function() {
    //     setTimeout(function() {
    //       fitText();
    //     }, 500);
    //   });
      
    //   // リサイズ時にも処理を実行
    //   $(window).on('resize', function() {
    //     clearTimeout(window.__fitTextTimer);
    //     window.__fitTextTimer = setTimeout(function() {
    //       if (window.innerWidth <= 767) {
    //         // 767px以下の場合は再計算
    //         fitText();
    //       } else {
    //         // 767pxを超えた場合はCSS変数をクリア
    //         $(".fit-text").each(function(){
    //           var $el = $(this);
    //           $el[0].style.removeProperty('--calculated-font-size-vw');
    //           $el[0].style.removeProperty('--original-font-size-px');
    //         });
    //       }
    //     }, 150);
    //   });
    // });
});